/*
 * View for Action API Endpoints
 */

define(["marionette", "./template/apiConfigTemplate.html"], function (
  Marionette,
  ApiConfigTemplate,
) {
  var ApiConfigView = {};

  ApiConfigView.apiConfigLayout = Marionette.Layout.extend({
    template: ApiConfigTemplate,
    regions: {
      list: "#apiList",
    },
    triggers: {
      "click #addApi": "add:api",
    },
  });

  return ApiConfigView;
});
